import React from 'react'
import MaskedInput from 'react-text-mask'
export const ISSNField = ({ inputRef, ...rest }) => {
  return (
    <MaskedInput
      {...rest}
      mask={[
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        '-',
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
      ]}
      placeholderChar={'\u2000'}
    />
  )
}

export default ISSNField



// WEBPACK FOOTER //
// ./src/components/Fields/ISSNField.js